export const AtlPreferencesMapper = {
  toAtlPreferencesFormData: atlPreference => {
    return {
      externalUserId: atlPreference.ExternalUserId,
      rank: atlPreference.Rank ?? null
    };
  },

  toApolloInput: atlPreference => {
    return {
      ExternalUserId: atlPreference.externalUserId,
      Rank: atlPreference.rank
    };
  }
};
